import { kettleNarrows } from './kettle-narrows';
import { lowerSable } from './lower-sable';
import { glacierTarn } from './glacier-tarn';
import type { SiteConfig } from '../engine/types';

export const SITES: Record<string, SiteConfig> = {
  [kettleNarrows.id]: kettleNarrows,
  [lowerSable.id]: lowerSable,
  [glacierTarn.id]: glacierTarn,
};

export function getSite(id: string): SiteConfig {
  const s = SITES[id];
  if (!s) throw new Error(`unknown site: ${id}`);
  return s;
}

export { kettleNarrows, lowerSable, glacierTarn };
